import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { mapSelbstbeteiligung } from '@ps20-frontend/migrations';
import { StatePreV1, StateV1 } from './1_migrate_selbstbeteiligung.interface';

export const migrateSelbstbeteiligung = (
  previousState: StatePreV1,
  newVersion: number,
): StateV1 => {
  return {
    ...previousState,
    version: newVersion,
    vertragsoptionen: {
      ...previousState.vertragsoptionen,
      selbstbeteiligung: mapSelbstbeteiligung(previousState.vertragsoptionen.selbstbeteiligung),
    } as Vertragsoptionen,
  };
};
